<template>
  <div class="account-orders">
    <h2>Оформленные заказы</h2>

    <div
      v-if="ORDERS.length"
      class="orders"
    >
      <vue-client-only>
        <div
          v-if="!adaptive.isMobile"
          class="legend"
        >
          <div class="number">
            Заказ
          </div>
          <div class="status">
            Статус
          </div>
          <div class="delivery">
            Доставка
          </div>
          <div class="payment">
            Оплата
          </div>
          <div class="price price-rub">
            Сумма
          </div>
        </div>
      </vue-client-only>

      <order-item
        v-for="order in ORDERS"
        :key="order.id"
        :order="order"
        @choose="openOrder"
      />
    </div>
    <page-info
      v-else
      class="page-info"
      title="Вы пока не оформили ни одного заказа"
    >
      Чтобы оформить заказ, добавьте товары в корзину или перейдите в каталог
      <a href="/">
        <ui-button
          class="button"
          text="Начать покупки"
        />
      </a>
    </page-info>

    <div
      v-if="ORDERS.length && !END"
      v-reached="load"
      class="loader"
    >
      <transition name="fade">
        <ui-loader size="60" v-if="PROGRESS" />
      </transition>
    </div>

    <order-support class="hint">
      <template v-if="ORDERS.length">
        Если вы хотите отказаться от заказа, объединить несколько заказов или изменить данные обращайтесь в службу поддержки пользователей FUNDAY по почте <a href="mailto:helpme@fundayshop.com">helpme@fundayshop.com</a> или по телефону <a href="tel:+78007700101">8 800 770-01-01</a> (по России бесплатно), с 7:00 до 22:00 (мск)
      </template>
      <template v-else>
        С вопросами обращайтесь в службу поддержки пользователей FUNDAY по почте <a href="mailto:helpme@fundayshop.com">helpme@fundayshop.com</a> или по телефону <a href="tel:+78007700101">8 800 770-01-01</a> (по России бесплатно), с 7:00 до 22:00 (мск)
      </template>
    </order-support>

    <order-popup />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import VueClientOnly from 'vue-client-only';
/* Components */
import PageInfo from '../../components/common/page-info';
import OrderItem from '../../components/account/order-item';
import OrderSupport from '../../components/account/order-support';
import OrderPopup from '@/components/account/order-popup.vue';

export default {
  name: 'account-orders',

  components: {
    OrderSupport,
    OrderItem,
    PageInfo,
    OrderPopup,
    VueClientOnly,
  },

  inject: ['adaptive'],

  computed: {
    ...mapGetters({
      ORDERS: 'orders/orders',
      PROGRESS: 'orders/loadProgress',
      END: 'orders/end',
    }),
  },

  mounted() {
    this.CLEAR_STORAGE();
  },

  methods: {
    ...mapActions({
      LOAD_ORDERS: 'orders/loadOrders',
      CLEAR_STORAGE: 'cart/clearAllFromStorageOrderNumbers',
    }),

    openOrder(number) {
      this.$f.showOldOrderPopup(number);
    },

    load() {
      if (this.END || this.PROGRESS) {
        return;
      }
      this.LOAD_ORDERS();
    }
  },

  serverPrefetch() {
    return Promise.all([
      this.LOAD_ORDERS()
    ]);
  }
};
</script>

<style lang="scss">
.account-orders {
  margin-top: 32px;

  .orders {
    margin-top: 20px;

    .legend {
      display: flex;
      padding: 24px 12px 16px;
      font-size: 12px;
      line-height: 16px;
      color: $gray;

      & > div {
        min-width: 116px;
        margin-right: 16px;
      }

      .price {
        width: 100%;
        margin-right: 0;
        text-align: end;
      }
    }

    .order-item:first-of-type {
      border-top: 1px solid $gray_lu;
    }
  }

  .page-info {
    margin-top: 56px;
    margin-bottom: 0;

    & > a {
      display: block;
    }

    .description {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .button {
      width: 138px;
      margin-top: 16px;
    }
  }

  & > .hint {
    margin-top: 56px;
  }

  & > .loader {
    display: flex;
    justify-content: center;
    margin: 41px auto 24px;
    color: $blue;
  }
}

@include breakpoint("tablet") {
  .account-orders {
    & > .loader {
      margin: 56px auto 40px;
    }

    .orders {
      margin-top: 0;

      .legend {
        border-bottom: 1px solid $gray_lu;

        & > div {
          min-width: 116px;
          margin-right: 24px;
        }

        & > .number {
          min-width: 144px;
        }

        & > .payment {
          margin-right: 0;
        }
      }
    }

    .page-info {
      margin-top: 80px;
    }

    & > .hint {
      margin-top: 48px;
    }
  }
}

@include breakpoint("desktop") {
  .account-orders {
    margin-top: 0;

    .orders {
      .legend {
        padding: 24px 20px 16px;
        font-size: 14px;

        & > div {
          margin-right: 24px;
        }

        .number {
          min-width: 164px;
        }

        .status,
        .delivery {
          min-width: 140px;
        }

        .payment {
          min-width: 160px;
        }
      }
    }

    .page-info {
      margin-top: 64px;
    }

    & > .hint {
      margin-top: 64px;
    }
  }
}
</style>
